const initialState = {
  includeCompleted: false,
  oldestFirst: false,
  limitToType: 'user',
  user: '',
};

export default initialState;
